import { memoCandidateColumn } from './columns.js'
import type { MemoCandidateColumn } from './columns.js'
import type { MemoTemplate } from './schema.js'

/**
 * The newsvalue filter the dialog opens with, one list per candidate column:
 * what the column's one source names, in descending newsvalue order.
 *
 * Kept per column - not one flat union - because a template can restrict its
 * columns differently, e.g. plannings at 4-5 but events at 4-6, and the
 * dialog's own filters should preserve that distinction rather than
 * collapsing it into a single shared range.
 *
 * A column is empty when its source is unrestricted, which the query treats
 * as "no newsvalue condition" rather than "nothing matches".
 */
export function initialNewsvalueFilter(template: MemoTemplate): Record<MemoCandidateColumn, string[]> {
  const newsvalues: Record<MemoCandidateColumn, Set<string>> = {
    print: new Set(),
    planning: new Set(),
    article: new Set(),
    events: new Set()
  }

  for (const source of template.sources) {
    const column = memoCandidateColumn(source.type)

    for (const newsvalue of source.newsvalues) {
      newsvalues[column].add(newsvalue)
    }
  }

  return {
    // A print article carries no newsvalue, so its column stays empty in
    // practice - the query leaves the condition out for it either way.
    print: [...newsvalues.print].sort((a, b) => Number(b) - Number(a)),
    planning: [...newsvalues.planning].sort((a, b) => Number(b) - Number(a)),
    article: [...newsvalues.article].sort((a, b) => Number(b) - Number(a)),
    events: [...newsvalues.events].sort((a, b) => Number(b) - Number(a))
  }
}
